import { Button, ButtonVariants, IconNames } from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import {
  StyledActionButtonsContainer,
  StyledHeaderContainer,
  StyledTitleHeader,
} from '@/app/shared/components/DataTable/StyledComponents/TableHeaderStyledComponents';

interface AllInvoicesTableHeaderProps {
  selectedInvoices: Set<string>;
  onUpdatePaymentStatus: () => void;
  paymentLinkUrl?: string;
}

export const AllInvoicesTableHeader = ({
  selectedInvoices,
  onUpdatePaymentStatus,
  paymentLinkUrl,
}: AllInvoicesTableHeaderProps) => {
  const { t } = useTranslation('billingReminder');

  return (
    <StyledTitleHeader>
      <StyledHeaderContainer>
        <span>{t('table.invoices')}</span>
        <StyledActionButtonsContainer>
          <Button
            variant={ButtonVariants.secondary}
            icon={IconNames.Currency_Card}
            iconLeft={true}
            onClick={onUpdatePaymentStatus}
            disabled={selectedInvoices.size === 0}
          >
            {t('button.updatePaymentStatus')}
          </Button>
          {paymentLinkUrl && (
            <a href={paymentLinkUrl} target="_blank" rel="noopener noreferrer">
              <Button icon={IconNames.Interface_Expand} iconRight={true}>
                {t('button.schedulePayment')}
              </Button>
            </a>
          )}
        </StyledActionButtonsContainer>
      </StyledHeaderContainer>
    </StyledTitleHeader>
  );
};
